'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_jsonCodecs$package$$anon$128() {
}
export { $c_Lmealorama_jsonCodecs$package$$anon$128 as $c_Lmealorama_jsonCodecs$package$$anon$128 };
$p = $c_Lmealorama_jsonCodecs$package$$anon$128.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_sr_AbstractPartialFunction();
$p.constructor = $c_Lmealorama_jsonCodecs$package$$anon$128;
/** @constructor */
function $h_Lmealorama_jsonCodecs$package$$anon$128() {
}
export { $h_Lmealorama_jsonCodecs$package$$anon$128 as $h_Lmealorama_jsonCodecs$package$$anon$128 };
$h_Lmealorama_jsonCodecs$package$$anon$128.prototype = $p;
$p.Q = (function(x) {
  return (false || false);
});
$p.N = (function(x, default$1) {
  return (false ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(x.am) : default$1.d(x));
});
var $d_Lmealorama_jsonCodecs$package$$anon$128 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_jsonCodecs$package$$anon$128, "mealorama.jsonCodecs$package$$anon$128", ({
  ID: 1,
  k: 1,
  f: 1,
  g: 1,
  a: 1
}));
export { $d_Lmealorama_jsonCodecs$package$$anon$128 as $d_Lmealorama_jsonCodecs$package$$anon$128 };
//# sourceMappingURL=mealorama.json-Codecs$package$$anon$128.js.map
